export default "__VITE_ASSET__BE$FNye2__"